module.exports = __webpack_public_path__ + "static/media/Roka.cab89182.svg";